import { h, Component } from 'preact';
import { joinClasses, accessNested } from 'utils/utils';

import s from 'components/bolt/button/button.sss';

export default class Button extends Component {

	constructor(props) {
		super(props);
		this.supportedTypes = ['primary', 'outlined', 'text', 'time', 'tag', 'floating', 'icon'];
	}

	render(props) {
		const {
			type,
			htmlType,
			active,
			class: className,
			activeClass,
			style,
			trigger,
			onMouseEnter,
			onMouseLeave,
			onMouseOut,
			onMouseDown,
			onKeyDown,
			onFocus,
			tabIndex,
			disabled,
			children,
			ariaLabel
		} = props;

		if (type && !this.supportedTypes.includes(type)) {
			console.error(`Bolt.Button does not support a type of ${type}. Supported types are: ${this.supportedTypes.join(', ')}`);
			return;
		}

		const backgroundColor = accessNested(style, 'backgroundColor');

		return (
			<button
				class={joinClasses(s.container, active && s.active, backgroundColor && s.noHover, s[type], className, active && activeClass)}
				style={style}
				onClick={trigger}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				onMouseDown={onMouseDown}
				onMouseOut={onMouseOut}
				onKeyDown={onKeyDown}
				onFocus={onFocus}
				disabled={disabled}
				tabIndex={tabIndex}
				ariaLabel={ariaLabel}
				type={htmlType}
			>
				{children}
			</button>
		);
	}
}
